import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../environments/environment';

export function isAllowedBoxDownloadUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== 'https:') {
      return false;
    }
    const host = parsed.hostname.toLowerCase();
    return host === 'api.box.com' || host === 'boxcloud.com' || host.endsWith('.boxcloud.com');
  } catch {
    return false;
  }
}

@Injectable({
  providedIn: 'root',
})
export class BoxService {
  currentToken: string;

  constructor(protected http: HttpClient) {}

  async getToken() {
    if (!this.currentToken) {
      const response = await this.http
        .get<{ accessToken: string; accessTokenTTLMS: number }>(`${env.APIUrl}/box/token`)
        .toPromise();
      this.currentToken = response.accessToken;

      setTimeout(
        () => {
          this.currentToken = null;
        },
        response.accessTokenTTLMS - 60 * 1000,
      );
    }
    return this.currentToken;
  }

  async download(url: string, token: string) {
    if (!isAllowedBoxDownloadUrl(url)) {
      return Promise.reject(new Error('Blocked download from non-Box URL'));
    }
    return await this.http
      .get(url, { responseType: 'blob', headers: { Authorization: `Bearer ${token}` } })
      .toPromise();
  }
}
